interface Config {
  apiBaseUrl: string;
}

// Default to development environment
const config: Config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://192.168.2.96:5000/api'
};

export default config;
